module.exports = __webpack_public_path__ + "static/media/ico_x.b82619cd.svg";